import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicLayout } from "@/components/PublicLayout";

import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import ForMembers from "@/pages/ForMembers";
import ForPartners from "@/pages/ForPartners";
import SportsPage from "@/pages/SportsPage";
import Facilities from "@/pages/Facilities";
import Support from "@/pages/Support";
import About from "@/pages/About";
import Login from "@/pages/Login";
import GetStarted from "@/pages/GetStarted";
import PaymentCallback from "@/pages/PaymentCallback";
import MemberDashboard from "@/pages/MemberDashboard";
import PartnerDashboard from "@/pages/PartnerDashboard";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/for-members" element={<ForMembers />} />
              <Route path="/for-partners" element={<ForPartners />} />
              <Route path="/sports" element={<SportsPage />} />
              <Route path="/facilities" element={<Facilities />} />
              <Route path="/about" element={<About />} />
              <Route path="/support" element={<Support />} />
            </Route>

            <Route path="/login" element={<Login />} />
            <Route path="/get-started" element={<GetStarted />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />

            <Route
              path="/dashboard/member"
              element={
                <ProtectedRoute allowedRoles={["member"]}>
                  <MemberDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/partner"
              element={
                <ProtectedRoute allowedRoles={["partner"]}>
                  <PartnerDashboard />
                </ProtectedRoute>
              }
            />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedRoles={["admin", "super_admin"]} redirectTo="/admin/login">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
